import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {DOCUMENT, isPlatformServer} from '@angular/common';

import {get} from "lodash";

let device = get(self, ['navigator', 'userAgent']);
if (!device) { device = get(self, ['navigator', 'vendor']); }
let platform:string = get(self, ['navigator', 'appVersion']);
if ("opera" in self) {
	device += " " + self['opera'];
}
let _isWindowPhone = typeof device === 'string' && /windows phone/i.test(device.toLowerCase());
let _isAndroid = typeof device === 'string' && /android/i.test(device.toLowerCase());
let _isIOS = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
let _isTouchScreen = ('ontouchstart' in document.documentElement || (navigator.maxTouchPoints > 0) || ((<any>navigator).msMaxTouchPoints > 0));

const versionData = {
	dataos: [
		{name: 'Windows Phone', value: 'Windows Phone', version: 'OS'},
		{name: 'Windows', value: 'Win', version: 'NT'},
		{name: 'iPhone', value: 'iPhone', version: 'OS'},
		{name: 'iPad', value: 'iPad', version: 'OS'},
		{name: 'Kindle', value: 'Silk', version: 'Silk'},
		{name: 'Android', value: 'Android', version: 'Android'},
		{name: 'PlayBook', value: 'PlayBook', version: 'OS'},
		{name: 'BlackBerry', value: 'BlackBerry', version: '/'},
		{name: 'Macintosh', value: 'Mac', version: 'OS X'},
		{name: 'Linux', value: 'Linux', version: 'rv'},
		{name: 'Palm', value: 'Palm', version: 'PalmOS'}
	],
	databrowser: [
		{name: 'Edge', value: 'Edge', version: 'Edge'}, //pre chromium Edge
		{name: 'Edge', value: 'Edg', version: 'Edg'}, //chromium Edge
		{name: 'Chrome', value: 'Chrome', version: 'Chrome'},
		{name: 'Chrome', value: 'CriOS', version: 'CriOS'},
		{name: 'Firefox', value: 'Firefox', version: 'Firefox'},
		{name: 'Safari', value: 'Safari', version: 'Version'},
		{name: 'Internet Explorer', value: 'Trident', version: 'rv'},
		{name: 'Opera', value: 'Opera', version: 'Opera'},
		{name: 'BlackBerry', value: 'CLDC', version: 'CLDC'},
		{name: 'Mozilla', value: 'Mozilla', version: 'Mozilla'}
	]
};

export function isIos() {
	return _isIOS;
}

export function isAndroid() {
	return _isAndroid;
}

export function isWindowsPhone() {
	return _isWindowPhone;
}

export function isMobile() {
	return _isIOS || _isAndroid || _isWindowPhone;
}

export function isTouchScreen() {
	return _isTouchScreen;
}

export enum browserType {
	Unknown = -1,
	IE = 1,
	Chrome,
	Firefox,
	Safari,
	Opera,
	Edge
}

export enum cpuType {
	Unknown = "",
	x86 = "x86",
	x64 = "x64"
}

// export let browserIcons = [
// 	{'title' : 'Chrome' , 'src': require('./icons/Chrome.png')},
// 	{'title' : 'Firefox' , 'src': require('./icons/Firefox.png')},
// 	{'title' : 'Safari' , 'src': require('./icons/Safari.png')},
// 	{'title' : 'Internet Explorer' , 'src': require('./icons/Internet.Explorer.png')},
// 	{'title' : 'Opera' , 'src': require('./icons/Opera.png')},
// 	{'title' : 'Edge' , 'src': require('./icons/Edge.png')}
// ];

let mapUAbrowserType = {
	'Chrome': browserType.Chrome,
	'Firefox': browserType.Firefox,
	'Safari': browserType.Safari,
	'MSIE': browserType.IE,
	'Trident': browserType.IE,
	'Edge': browserType.Edge,
	'unknown': browserType.Unknown
};

@Injectable()
export class BrowserAttributes {
	browserName: browserType = browserType.Unknown; // for use with the browseType Enum
	browser_name: string; //simple string representation
	browserVersion: number;
	osName: string; // may contain version number
	osVersion: number;
	cpuClass: string;
	isTabletPC: boolean = false;
	resolution: string;

	public ios: boolean = false;
	public isInit:boolean = false;
	public _isNode:boolean = false;

	public isNode(){
		return this._isNode;
	}

	public isIos = ()=>{return isIos();};
    public isTouchScreen = ()=>{return isTouchScreen();};
	public isMobile = ()=>{return isMobile();};

	public isIE() {
		this.ensureInitialized();
		return this.browserName === browserType.IE;
	}

	constructor(@Inject(PLATFORM_ID) public platformId: Object, @Inject(DOCUMENT) private doc) {

	}

	public detectBrowser(): browserType {
		this.ensureInitialized();
		return this.browserName;
	}

	public init(){
		this.isInit = true;
		if (isPlatformServer(this.platformId)){
			this._isNode=true;
			this.ios=false;
		}else{
			this._isNode=false;

			const {browser, os} = this.detectUA();
			this.browser_name = browser.name;
			this.browserName = mapUAbrowserType[browser.name];
			this.browserVersion = browser.version;
			this.osName = os.name;
			this.osVersion = os.version;
			// Opera 8.0+
			let isOpera = (!!self["opr"] && !!self["opr"].addons) || !!self["opera"] || navigator.userAgent.indexOf(' OPR/') >= 0;
			// Firefox 1.0+
			let isFirefox = typeof self["InstallTrigger"] !== 'undefined';
			// At least Safari 3+: "[object HTMLElementConstructor]"
			let isSafari = Object.prototype.toString.call(self["HTMLElement"]).indexOf('Constructor') > 0;
			// Internet Explorer 6-11
			let isIE = !!self.document && !!self.document["documentMode"];
			// Pre chromium edge 20+
			let isEdge = !isIE && !!self["StyleMedia"];
			// Chrome 1+
			let isChrome = !!self['chrome'] && !!self['chrome'].webstore;
			if (isOpera) {
				this.browserName = browserType.Opera;
			} else if (isFirefox) {
				this.browserName = browserType.Firefox;
			} else if (isSafari) {
				this.browserName = browserType.Safari;
			} else if (isIE) {
				this.browserName = browserType.IE;
			} else if (isEdge) {
				this.browserName = browserType.Edge;
			} else if (isChrome) {
				this.browserName = browserType.Chrome;
			}

			this.cpuClass = this.detectCPUClass();

			if (platform.indexOf("Windows NT 6.1") !== -1) {
				this.osName = "Win7";
			} else if (platform.indexOf("Windows NT 6.") !== -1) {
				this.osName = "Win8";
			} else if (platform.indexOf("Windows NT 10") !== -1) {
				this.osName = "Win10";
			} else if (platform.indexOf("Macintosh") !== -1) {
				this.osName = "Mac OS X";
			} else if (isIos()) {
				this.osName = "iOS";
			}

			if (_isTouchScreen && isIE) {
				const TabletPCRegExp = new RegExp("Tablet PC");
				if (TabletPCRegExp.test(navigator.userAgent)) {
					this.isTabletPC = true;
				}
			}
			if (!_isTouchScreen) {
				this.resolution = window.screen.width.toString() + "x" + window.screen.height.toString();
			} else{
				this.resolution = (window.screen.width * window.devicePixelRatio).toString() + "x" + (window.screen.height * window.devicePixelRatio).toString();
			}
		}
	}

	private detectUA(): { browser: { name: string, version: number }, os: { name: string, version: number } } {
		const agent = [device, platform].join(' '),
			os = this.matchItem(agent, versionData.dataos),
			browser = this.matchItem(agent, versionData.databrowser);
		return {os, browser};
	}

	private matchItem(string, data) {
		let i = 0,
			j = 0,
			html = '',
			regex,
			regexv,
			match,
			matches,
			version;

		for (i = 0; i < data.length; i += 1) {
			regex = new RegExp(data[i].value, 'i');
			match = regex.test(string);
			if (match) {
				regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
				matches = string.match(regexv);
				version = '';
				if (matches) { if (matches[1]) { matches = matches[1]; } }
				if (matches) {
					matches = matches.split(/[._]+/);
					for (j = 0; j < matches.length; j += 1) {
						if (j === 0) {
							version += matches[j] + '.';
						} else {
							version += matches[j];
						}
					}
				} else {
					version = '0';
				}
				return {
					name: data[i].name,
					version: parseFloat(version)
				};
			}
		}
		return {name: 'unknown', version: 0};
	}

	private detectCPUClass(): string {
		const cc = self.navigator['cpuClass'];
		if (this.browserName === browserType.IE && cc) {
			return cc.toLowerCase();
		} else {
			return "undefined";
		}
	}

	private ensureInitialized() {
		if (!this.isInit) {
			this.init();
		}
	}
}











